import { gtagLineEvent } from "@/utils/gtag";

const LINE_URL = "https://lin.ee/z9MioSs";
const GTAG_EVENT = "YAMEBI_1_LINE友達追加_LINE追加後の流れセクション";

const steps = [
  {
    step: "01",
    title: "公式LINEを友だち追加",
    desc: "まずはYAMEBIの案内を受け取ります。",
    icon: "ri-user-add-fill",
  },
  {
    step: "02",
    title: "購入コントロールの仕組みを確認",
    desc: "どうやって「買えない環境」をつくるのかを確認できます。",
    icon: "ri-search-2-fill",
  },
  {
    step: "03",
    title: "自分に合う使い方を確認",
    desc: "平日だけ甘いものを制限したい、週何回まではOK、などの使い方を確認できます。",
    icon: "ri-settings-4-fill",
  },
  {
    step: "04",
    title: "納得した場合のみ利用開始",
    desc: "内容を確認したうえで、自分に合うと思った場合に利用を始められます。",
    icon: "ri-check-double-fill",
  },
];

export default function LineFlowSection() {
  return (
    <section className="bg-white py-20 px-6">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-12">
          <p className="text-sm text-[#00A000] font-bold tracking-widest uppercase mb-3">FLOW</p>
          <h2 className="text-2xl md:text-3xl font-black text-[#1a1a1a] leading-tight">
            LINE追加後は、<br />
            <span className="text-[#00B900]">まず内容確認だけでOK</span>です
          </h2>
        </div>

        <div className="relative">
          {/* 縦線 */}
          <div className="absolute left-7 top-10 bottom-10 w-0.5 bg-[#D0EDD0] hidden md:block"></div>

          <div className="space-y-6">
            {steps.map((s, i) => (
              <div key={i} className="flex items-start gap-5">
                <div className="flex-shrink-0 w-14 h-14 flex items-center justify-center bg-[#E8F8E8] border-2 border-[#00B900] rounded-full z-10">
                  <i className={`${s.icon} text-xl text-[#00B900]`}></i>
                </div>
                <div className="bg-[#F8FCF8] border border-[#E0F0E0] rounded-xl p-5 flex-1">
                  <span className="text-xs text-[#00A000] font-bold">STEP {s.step}</span>
                  <h3 className="text-[#1a1a1a] font-bold text-base mt-1 mb-1">{s.title}</h3>
                  <p className="text-[#666] text-sm leading-relaxed">{s.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-10 text-center">
          <a
            href={LINE_URL}
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => { e.preventDefault(); gtagLineEvent(LINE_URL, GTAG_EVENT); }}
            className="whitespace-nowrap inline-flex items-center gap-2 bg-[#00B900] hover:bg-[#009900] text-white font-bold text-base py-4 px-10 rounded-full transition-all cursor-pointer hover:scale-105 shadow-[0_8px_25px_rgba(0,185,0,0.5)] hover:shadow-[0_12px_35px_rgba(0,185,0,0.65)]"
          >
            <span className="w-6 h-6 flex items-center justify-center">
              <i className="ri-line-fill text-xl"></i>
            </span>
            公式LINEを友だち追加する
          </a>
          <p className="text-[#888] text-xs mt-2">まずはLINEで内容を確認する</p>
        </div>
      </div>
    </section>
  );
}
